<template>
  <div>
    <organizational-structure-menu></organizational-structure-menu>

    <h1>{{ $t("settings.organisationStructure.title") }}</h1>

    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          :disabled="selected.length === 0"
          @click="
            dialog = true;
            newOrganisationId = null;
          "
          block
          color="accent"
          >{{ $t("global.editSelected") }}</v-btn
        >
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="users" :search="search" v-model="selected" show-select>
      <template #item="props">
        <tr>
          <td>
            <v-checkbox hide-details primary @change="props.select" :value="props.isSelected" class="ma-0 pa-0" />
          </td>
          <td class="text-left">{{ props.item.name }}</td>
          <td class="text-left">{{ props.item.surname }}</td>
          <td class="text-left">{{ props.item.login }}</td>
          <td class="text-left">{{ props.item.email }}</td>
          <td class="text-left">
            {{
              typeof organizationStructureList.find(v => v.id === props.item.organization_structure_id) === "undefined"
                ? ""
                : organizationStructureList.find(v => v.id === props.item.organization_structure_id).name
            }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn
                  v-on="on"
                  @click="
                    selected = [props.item];
                    dialog = true;
                    newOrganisationId = props.item.organization_structure_id;
                  "
                  icon
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog max-width="500px" persistent v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.organisationStructure.setNewStructureForUsersTitle") }}</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="editedHeaders"
            :items="selected"
            hide-default-footer
            :footer-props="{ 'items-per-page-options': [{ text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }] }"
          >
            <template #item="props">
              <tr>
                <td class="text-left">{{ props.item.name }} {{ props.item.surname }}</td>
                <td class="text-left">{{ props.item.login }}</td>
                <td class="text-left">{{ props.item.email }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-select
            :items="organizationStructureList"
            :label="$t('settings.organisationStructure.suitableOrganizationalStructure')"
            clearable
            item-text="name"
            item-value="id"
            v-model="newOrganisationId"
          >
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OrganizationalStructureMenu from "../../../components/Settings/OrganizationalStructureMenu";

export default {
  name: "SettingsOrganizationalStructureUsersView",
  components: { OrganizationalStructureMenu },
  data: () => ({
    selected: [],
    newOrganisationId: null,
    users: [],
    search: "",
    dialog: null,
    organizationStructureList: []
  }),
  created() {
    this.downloadStructure();
    this.downloadUsers();
  },
  computed: {
    headers() {
      return [
        { text: this.$t("settings.users.fields.name.name"), value: "name" },
        {
          text: this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" },
        {
          text: this.$t("settings.users.fields.organizationStructure.name"),
          value: "organization_structure_id"
        },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    editedHeaders() {
      return [
        {
          text: this.$t("settings.users.fields.name.name") + " " + this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" }
      ];
    },
    items() {
      return this.getChilds();
    }
  },
  methods: {
    showContextMenu(e, item /*, leaf*/) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.currentItem = JSON.parse(JSON.stringify(item));
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    addNew() {
      this.currentItem = {
        id: null,
        name: null,
        cost_centre: null,
        count_users: null,
        parent: this.currentItem,
        parent_id: this.currentItem.id,
        children: []
      };
      this.dialog = true;
    },
    edit() {
      this.dialog = true;
    },
    downloadStructure() {
      this.axios.get("settings/organization-structure/list").then(resp => {
        this.organizationStructureList = resp.data;
      });
    },
    downloadUsers() {
      this.axios.get("settings/organization-structure/users").then(resp => {
        this.users = resp.data;
        this.unselectAllUsers();
      });
    },
    unselectAllUsers() {
      for (let userIndex in this.users) {
        this.users[userIndex].selected = false;
      }
    },
    save() {
      let selectedUserId = [];
      for (let user of this.selected) {
        selectedUserId.push(user.id);
      }
      this.axios
        .post("settings/organization-structure/save-users", {
          users: selectedUserId,
          organization_structure_id: this.newOrganisationId
        })
        .then(() => {
          this.downloadUsers();
          this.dialog = false;
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        })
        .catch(() => {
          //TODO OBSLUGA BLEDOW
        });
    }
  }
};
</script>

<style scoped></style>
